import { WebApiError } from "@faire/web-api--source/WebApiError";
import { getWebApiErrorMessage } from "@faire/web/common/getErrorMessage";
import { useStrictLocalization } from "@faire/web/common/localization";

export const useHumanReadableErrorMessage = () => {
  const { strictLocalize } = useStrictLocalization();

  const humanReadableErrorMessage = (error: unknown): string => {
    const genericFallback = strictLocalize({
      id: "JqiqNj",
      defaultMessage: "Something went wrong",
    });

    if (error instanceof WebApiError) {
      const status = error.httpStatusCode;

      if (!status || status >= 500) {
        return genericFallback;
      }

      return getWebApiErrorMessage(error, strictLocalize, genericFallback);
    }

    return genericFallback;
  };

  return { humanReadableErrorMessage };
};
